angular.module('schoolLinqApp').directive('positiveDecimalOnly', function () {
	return {
		restrict: 'A',
		link: function (scope, element, attrs) {
			function validateInput(event) {
				const keyCode = event.which ? event.which : event.keyCode;
				const char = String.fromCharCode(keyCode);
				const regex = /^[0-9]*\.?[0-9]*$/;

				if (!regex.test(char)) {
					event.preventDefault();
				}
			}

			function validatePaste(event) {
				const clipboardData = event.clipboardData || event.originalEvent.clipboardData || window.Clipboard;
				const pastedData = clipboardData.getData('text');
				const regex = /^[0-9]*\.?[0-9]*$/;

				if (!regex.test(pastedData)) {
					event.preventDefault();
				}
			}

			element.on('keypress', validateInput);
			element.on('paste', validatePaste);
		},
	};
});
